import { Component, OnInit } from '@angular/core';
import { Application } from '../../../shared/user.model';
import { UserService } from '../../../shared/user.service';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import swal1 from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
import { ErrorHandler } from '../../../shared/ErrorHandler';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-district-form',
  templateUrl: './district-form.component.html',
  styleUrls: ['./district-form.component.css']
})
export class DistrictFormComponent implements OnInit {

  title="Add District";
  data : any = {};
  formInvalid : boolean = false;
  d : any = {};

  DI_Id : number;
  mode : string;

  constructor(private userService: UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    private datePipe:DatePipe) 
  { }

  ngOnInit() {
    this.route.params.subscribe(params => {      
      this.DI_Id = params['DI_Id'];  
      this.mode  =   params['mode'];   
        
        if(this.DI_Id > 0){
          this.GetDistrictById(this.DI_Id)
        }    
    });

    if(this.mode=='view'){
      this.title = "View Case Proceedings";
    }
    else if(this.mode=='edit'){
      this.title = "Edit Case Proceedings";
    }  
  }

  SaveDistrict(Distict: NgForm){    
    if(Distict.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }     

    else{                                     
            this.data = this.userService.PostDistrict(Distict.value);    
            this.data.subscribe(
            (response) => {
              Distict.reset();
              Distict.resetForm();
              Distict.form.markAsPristine();
              Distict.form.markAsUntouched();        
              swal('Success!', 'Districtt Added Successfully .', 'success');
              this.router.navigate(['/home/district']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    
    } 
  }

  GetDistrictById(DI_Id){
    document.getElementById('loader-spinner').style.display = "block";
        this.data = this.userService.GetByIdDistrict(DI_Id);
        this.data.subscribe(
          (response: any) => {
            this.d = response;        
            
            // if (this.ap.AP_Date != null)
            //   this.ap.AP_Date = ((this.ap.AP_Date).split('T'))[0];
            // if (this.ap.AP_Date != null)
            //  this.ap.AP_Date = ((this.ap.AP_Date).split('T'))[0];    
                    
    
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
          });
  }
  UpdateDistrict(District: NgForm) {  
    this.data = this.userService.UpdateDistrict(District.value,this.DI_Id);
   this.data.subscribe(
     (response) => {
      District.reset();
      District.resetForm();
      District.form.markAsPristine();
      District.form.markAsUntouched();           
                   
       swal('Success!', 'District updated Successfully .', 'success');
       document.getElementById('loader-spinner').style.display = "none";   
       this.router.navigate(['/home/district']) ;          
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401) {
         this.errorHandler.HandlerError(error);
       }
       else if (error.status == 400) {
         swal('Warning!', error.error.Message, 'warning');
       }
     });   
}

Cancel(){
//this.router.navigate(['/home/district']) ; 
this.d.DI_District='';
this.d.DI_Code='';
}




  

}



// WEBPACK FOOTER //
// ./src/app/master/district/district-form/district-form.component.ts